export default __webpack_public_path__ + "de7674ac9c376acabed8566baac62735.svg";